var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
// import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
// import ExclamationCircleFilled from '@ant-design/icons/ExclamationCircleFilled';
// import CloseCircleFilled from '@ant-design/icons/CloseCircleFilled';
// import CheckCircleFilled from '@ant-design/icons/CheckCircleFilled';
// import InfoCircleFilled from '@ant-design/icons/InfoCircleFilled';
// import CloseOutlined from '@ant-design/icons/CloseOutlined';
import FilledSuccess from 'acud-icon/lib/icons/FilledSuccess';
import FilledWarn from 'acud-icon/lib/icons/FilledWarn';
import FilledInfo from 'acud-icon/lib/icons/FilledInfo';
import FilledError from 'acud-icon/lib/icons/FilledError';
import CloseOutlined from 'acud-icon/lib/icons/OutlinedClose';
import { Notice } from 'rc-notification';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
// export const TypeIcon = {
//     info: <InfoCircleFilled />,
//     success: <CheckCircleFilled />,
//     error: <CloseCircleFilled />,
//     warning: <ExclamationCircleFilled />,
//     loading: <LoadingOutlined />,
// };
export function getCloseIcon(prefixCls, closeIcon) {
    return (closeIcon || (<span className={`${prefixCls}-close-x`}>
                <CloseOutlined className={`${prefixCls}-close-icon`}/>
            </span>));
}
const typeToIcon = {
    success: FilledSuccess,
    info: FilledInfo,
    error: FilledError,
    warning: FilledWarn,
};
export function PureContent({ prefixCls, icon, type, message, description, btn, }) {
    let iconNode = null;
    if (icon) {
        iconNode = <span className={`${prefixCls}-icon`}>{icon}</span>;
    }
    else if (type) {
        iconNode = React.createElement(typeToIcon[type] || null, {
            className: classNames(`${prefixCls}-icon`, `${prefixCls}-icon-${type}`),
        });
    }
    return (<div className={classNames({
            [`${prefixCls}-with-icon`]: iconNode,
        })} role="alert">
            {iconNode}
            <div className={`${prefixCls}-message`}>{message}</div>
            <div className={`${prefixCls}-description`}>{description}</div>
            {btn && <div className={`${prefixCls}-btn`}>{btn}</div>}
        </div>);
}
/** @private Internal Component. Do not use in your production. */
export default function PurePanel(props) {
    const { prefixCls: staticPrefixCls, className, icon, type, message, description, btn, closable = true, closeIcon } = props, restProps = __rest(props, ["prefixCls", "className", "icon", "type", "message", "description", "btn", "closable", "closeIcon"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = staticPrefixCls || getPrefixCls('notification');
    const noticePrefixCls = `${prefixCls}-notice`;
    // const [, hashId] = useStyle(prefixCls);
    return (<Notice {...restProps} prefixCls={prefixCls} className={classNames(className, `${noticePrefixCls}-pure-panel`)} eventKey="pure" duration={null} closable={closable} closeIcon={getCloseIcon(prefixCls, closeIcon)} content={<PureContent prefixCls={noticePrefixCls} icon={icon} type={type} message={message} description={description} btn={btn}/>}/>);
}
